import React, { useState } from 'react';

import Dialog from '@dashboard/components/Dialog';
import Form from '@dashboard/components/Formik/Form';
import useUserQueries from '@dashboard/hooks/queries/useUserQueries';
import { toast } from '@dashboard/context/ToastContext';
import { useAuth } from '@/dashboard/context/AuthContext/AuthContext';

const SetPasswordDialog = ({ open, onCancel, onSuccess }) => {
  const { setPassword } = useUserQueries();
  const { setUser } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = async values => {
    setIsSubmitting(true);

    const { error } = await setPassword(values);

    setIsSubmitting(false);

    if (error) {
      return {
        data: null,
        error,
      };
    } else {
      toast({
        title: 'Password set successfully',
        type: 'success',
      });
      onSuccess?.();

      setUser(user => ({
        ...user,
        authProvider: 'both',
      }));

      return {
        data: values,
        error: null,
      };
    }
  };

  if (!open) return null;

  return (
    <Dialog
      title="Set password"
      description="This will allow you to log in using your email and password."
      open={open}
      onCancel={onCancel}
      size="lg"
      confirmButton={null}
      cancelButton={null}
    >
      <Form
        initialValues={{
          password: '',
          confirmPassword: '',
        }}
        onSubmit={handleFormSubmit}
        fields={[
          {
            name: 'password',
            required: true,
            type: 'password',
            label: 'Password',
            placeholder: 'Enter your password',
            autocomplete: 'new-password',
          },
          {
            name: 'confirmPassword',
            required: true,
            type: 'password',
            label: 'Confirm password',
            placeholder: 'Confirm your password',
            autocomplete: 'new-password',
          },
        ]}
        submitButton={{
          label: 'Set password',
          appearance: 'primary',
          loading: isSubmitting,
        }}
        cancelButton={{
          label: 'Cancel',
          appearance: 'light',
          onClick: onCancel,
        }}
        showState={false}
        formSubmitAlign="end"
      />
    </Dialog>
  );
};

export default SetPasswordDialog;
